import {Component, Input, OnInit} from '@angular/core';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';
import { ClientUser } from '@app/shared/models/client-user';
import { BaseWithIdList } from '@app/shared/models/list';
import { UserRole } from '@app/shared/models/user-role';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { PatchValue } from '@app/shared/components/base/base-patch.component';


@Component({
    selector: 'user-permission-roles',
    templateUrl: './user-permission-roles.component.html'
})
export class UserPermissionRolesComponent extends TwoWayBoundComponent<ClientUser>
                                          implements OnInit {

    @Input()
    public roles: BaseWithIdList<UserRole>;

    public validationMissingRoles: boolean;

    public touched: boolean;

    get user() {
        return this.bananaBox;
    }

    get selectedRoles(): string[] {
        return this.bananaBox ? (<UserRole[]>this.bananaBox.roles).map(role => role.key) : [];
    }

    constructor() {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();
        this.touched = false;
    }

    public updateRoles(selectedRoles: PatchValue): void {
        this.bananaBox.roles = this.roles.items.filter(role => {
            return selectedRoles.value && (<string[]>selectedRoles.value).indexOf(role.key) > -1;
        });

        this.validationMissingRoles = !this.selectedRoles || this.selectedRoles.length === 0;
    }

    public getRolesError(): string {
        return this.validationMissingRoles ? marker('user_management.error.roles.required') :
                                             '';
    }

    public valid(andTouch?: boolean): boolean {
        if (!this.touched && andTouch) {
            this.touched = !!andTouch;
        }

        this.validationMissingRoles = !this.selectedRoles || this.selectedRoles.length === 0;
        return !this.touched || !this.validationMissingRoles;
    }
}
